

module.exports = __webpack_require__.stylable.create(
    "horizontalmenuitem2694933250",
    {"classes":{"root":"horizontalmenuitem2694933250__root","positionBox":"horizontalmenuitem2694933250__positionBox","opened":"horizontalmenuitem2694933250__opened","collapsed":"horizontalmenuitem2694933250__collapsed","expanded":"horizontalmenuitem2694933250__expanded","container":"horizontalmenuitem2694933250__container","label":"horizontalmenuitem2694933250__label"},"vars":{},"stVars":{},"keyframes":{"expandSubmenu":"horizontalmenuitem2694933250__expandSubmenu"}},
    "",
    1,
    111,
    null
);
